import { ZERO_FIAT_AMOUNT } from "@hsbc/shared";
import type { RewardsPaymentContext } from "@hsbc/types";

export const getInitialRewardsPaymentContext = (): RewardsPaymentContext => ({
  rewardsSelected: false,
  rewardsAmountToApply: 0,
  rewardsAmountToPayInCash: ZERO_FIAT_AMOUNT,
  rewardsBalance: 0,
  rewardsBalanceInCash: ZERO_FIAT_AMOUNT,
  error: false,
});
